import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import { Controller } from "react-hook-form";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	slotProps: {
		paper: {
			style: {
				maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			},
		},
	},
};

const ControlledSelectSeparatedLabel = ({
	control,
	name,
	label,
	defaultValue,
	options,
	labelProps,
	margin,
	labelXs = 5,
	fieldXs = 7,
	...rest
}) => {
	return (
		<Controller
			control={control}
			name={name}
			defaultValue={defaultValue}
			render={({ field: { onChange, value } }) => (
				<Grid container columnSpacing={2} rowSpacing={0}>
					<Grid sx={{ display: "flex", alignItems: "center" }} size={labelXs}>
						<Typography
							variant="label"
							component="label"
							htmlFor={name}
							sx={{ ...labelProps }}
						>
							{label}:
						</Typography>
					</Grid>
					<Grid sx={{ display: "flex", alignItems: "center" }} size={fieldXs}>
						<FormControl fullWidth margin={margin ? margin : "none"}>
							{/* <InputLabel size="small" id={name}>
							{label}
						</InputLabel> */}
							<Select
								labelId={name}
								onChange={onChange}
								value={value}
								// label={label}
								size="small"
								MenuProps={MenuProps}
								{...rest}
							>
								{options.map((option) => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Grid>
				</Grid>
			)}
		/>
	);
};

export default ControlledSelectSeparatedLabel;
